<template>
  <section class="add-nota-modal history-modal relative"
           @mousedown="_clickModal">
    <i class="close-icon absolute pointer"
       v-html="svg.close"
       @click="Handle_Close" />
    <div class="flex">
      <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(submit)">

            <!-- DATEPICKER -->
            <validation-provider rules="required"
                                 v-slot="{ errors }">
              <div class="relative">
                <i class="absolute left0 top0 flex-center">
                  <svg width="20px" height="21px" viewBox="0 0 20 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <path d="M18.75,2.125 L13.75,2.125 L13.75,0.875 C13.75,0.70572832 13.6881517,0.55924541 13.5644531,0.435546875 C13.4407546,0.31184834 13.2942717,0.25 13.125,0.25 C12.9557283,0.25 12.8092454,0.31184834 12.6855469,0.435546875 C12.5618483,0.55924541 12.5,0.70572832 12.5,0.875 L12.5,2.125 L7.5,2.125 L7.5,0.875 C7.5,0.70572832 7.43815166,0.55924541 7.31445312,0.435546875 C7.19075459,0.31184834 7.04427168,0.25 6.875,0.25 C6.70572832,0.25 6.55924541,0.31184834 6.43554688,0.435546875 C6.31184834,0.55924541 6.25,0.70572832 6.25,0.875 L6.25,2.125 L1.25,2.125 C0.898435742,2.125 0.602214746,2.2454415 0.361328125,2.48632812 C0.120441504,2.72721475 0,3.02343574 0,3.375 L0,19 C0,19.3385434 0.120441504,19.6315092 0.361328125,19.8789062 C0.602214746,20.1263033 0.898435742,20.25 1.25,20.25 L18.75,20.25 C19.1015643,20.25 19.3977853,20.1263033 19.6386719,19.8789062 C19.8795585,19.6315092 20,19.3385434 20,19 L20,3.375 C20,3.02343574 19.8795585,2.72721475 19.6386719,2.48632812 C19.3977853,2.2454415 19.1015643,2.125 18.75,2.125 Z M18.75,19 L1.25,19 L1.25,3.375 L6.25,3.375 L6.25,4 C6.25,4.16927168 6.31184834,4.31575459 6.43554688,4.43945312 C6.55924541,4.56315166 6.70572832,4.625 6.875,4.625 C7.04427168,4.625 7.19075459,4.56315166 7.31445312,4.43945312 C7.43815166,4.31575459 7.5,4.16927168 7.5,4 L7.5,3.375 L12.5,3.375 L12.5,4 C12.5,4.16927168 12.5618483,4.31575459 12.6855469,4.43945312 C12.8092454,4.56315166 12.9557283,4.625 13.125,4.625 C13.2942717,4.625 13.4407546,4.56315166 13.5644531,4.43945312 C13.6881517,4.31575459 13.75,4.16927168 13.75,4 L13.75,3.375 L18.75,3.375 L18.75,19 Z M14.375,10.25 L15.625,10.25 C15.7942717,10.25 15.9407546,10.1881517 16.0644531,10.0644531 C16.1881517,9.94075459 16.25,9.79427168 16.25,9.625 L16.25,8.375 C16.25,8.20572832 16.1881517,8.05924541 16.0644531,7.93554688 C15.9407546,7.81184834 15.7942717,7.75 15.625,7.75 L14.375,7.75 C14.2057283,7.75 14.0592454,7.81184834 13.9355469,7.93554688 C13.8118483,8.05924541 13.75,8.20572832 13.75,8.375 L13.75,9.625 C13.75,9.79427168 13.8118483,9.94075459 13.9355469,10.0644531 C14.0592454,10.1881517 14.2057283,10.25 14.375,10.25 Z M14.375,15.25 L15.625,15.25 C15.7942717,15.25 15.9407546,15.1881517 16.0644531,15.0644531 C16.1881517,14.9407546 16.25,14.7942717 16.25,14.625 L16.25,13.375 C16.25,13.2057283 16.1881517,13.0592454 16.0644531,12.9355469 C15.9407546,12.8118483 15.7942717,12.75 15.625,12.75 L14.375,12.75 C14.2057283,12.75 14.0592454,12.8118483 13.9355469,12.9355469 C13.8118483,13.0592454 13.75,13.2057283 13.75,13.375 L13.75,14.625 C13.75,14.7942717 13.8118483,14.9407546 13.9355469,15.0644531 C14.0592454,15.1881517 14.2057283,15.25 14.375,15.25 Z M10.625,12.75 L9.375,12.75 C9.20572832,12.75 9.05924541,12.8118483 8.93554688,12.9355469 C8.81184834,13.0592454 8.75,13.2057283 8.75,13.375 L8.75,14.625 C8.75,14.7942717 8.81184834,14.9407546 8.93554688,15.0644531 C9.05924541,15.1881517 9.20572832,15.25 9.375,15.25 L10.625,15.25 C10.7942717,15.25 10.9407546,15.1881517 11.0644531,15.0644531 C11.1881517,14.9407546 11.25,14.7942717 11.25,14.625 L11.25,13.375 C11.25,13.2057283 11.1881517,13.0592454 11.0644531,12.9355469 C10.9407546,12.8118483 10.7942717,12.75 10.625,12.75 Z M10.625,7.75 L9.375,7.75 C9.20572832,7.75 9.05924541,7.81184834 8.93554688,7.93554688 C8.81184834,8.05924541 8.75,8.20572832 8.75,8.375 L8.75,9.625 C8.75,9.79427168 8.81184834,9.94075459 8.93554688,10.0644531 C9.05924541,10.1881517 9.20572832,10.25 9.375,10.25 L10.625,10.25 C10.7942717,10.25 10.9407546,10.1881517 11.0644531,10.0644531 C11.1881517,9.94075459 11.25,9.79427168 11.25,9.625 L11.25,8.375 C11.25,8.20572832 11.1881517,8.05924541 11.0644531,7.93554688 C10.9407546,7.81184834 10.7942717,7.75 10.625,7.75 Z M5.625,7.75 L4.375,7.75 C4.20572832,7.75 4.05924541,7.81184834 3.93554688,7.93554688 C3.81184834,8.05924541 3.75,8.20572832 3.75,8.375 L3.75,9.625 C3.75,9.79427168 3.81184834,9.94075459 3.93554688,10.0644531 C4.05924541,10.1881517 4.20572832,10.25 4.375,10.25 L5.625,10.25 C5.79427168,10.25 5.94075459,10.1881517 6.06445312,10.0644531 C6.18815166,9.94075459 6.25,9.79427168 6.25,9.625 L6.25,8.375 C6.25,8.20572832 6.18815166,8.05924541 6.06445312,7.93554688 C5.94075459,7.81184834 5.79427168,7.75 5.625,7.75 Z M5.625,12.75 C5.79427168,12.75 5.94075459,12.8118483 6.06445312,12.9355469 C6.18815166,13.0592454 6.25,13.2057283 6.25,13.375 L6.25,14.625 C6.25,14.7942717 6.18815166,14.9407546 6.06445312,15.0644531 C5.94075459,15.1881517 5.79427168,15.25 5.625,15.25 L4.375,15.25 C4.20572832,15.25 4.05924541,15.1881517 3.93554688,15.0644531 C3.81184834,14.9407546 3.75,14.7942717 3.75,14.625 L3.75,13.375 C3.75,13.2057283 3.81184834,13.0592454 3.93554688,12.9355469 C4.05924541,12.8118483 4.20572832,12.75 4.375,12.75 L5.625,12.75 Z" id="" fill="#FFFFFF" fill-rule="nonzero"></path>
                    </g>
                  </svg>
                </i>
                <datepicker v-model="data.createdAt"
                            :class="{'invalid-input': errors[0]}"
                            :monday-first="true"
                            :language="$data.ro"
                            :format="_customFormatter"
                            :disabled-dates="$data.disabledDates"
                            placeholder="data"
                            name="uniquename" />
              </div>
            </validation-provider>

            <!--  DINTI DD -->
            <div class="mtop12px relative">
              <i class="absolute left0 top0 flex-center">
                <svg width="19px" height="21px" viewBox="0 0 19 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <path d="M18.6634963,3.83983229 C18.1098101,2.0972825 16.9294357,0.818414604 15.4250186,0.331066678 C12.6514312,-0.567422101 10.3707085,0.587824633 9.5,1.14087963 C8.62917714,0.587783617 6.34841383,-0.567422101 3.57498875,0.331066678 C2.07012509,0.818537651 0.889628901,2.09789773 0.336105096,3.84110378 C-0.391762669,6.1333863 0.0782839157,8.73012797 1.59362283,10.7873088 C2.252427,11.6818191 2.69786892,12.6679173 2.91752444,13.718287 C3.01509047,14.184963 3.09990755,14.6983969 3.16958017,15.2443972 C3.37880105,16.8840798 3.68692781,18.2001078 4.08547469,19.1558955 C4.5628702,20.3008473 5.1787583,20.9191582 5.91600508,20.9936426 C5.9579873,20.9978672 5.99944169,21 6.04065248,21 C6.76628715,21 7.37275565,20.342027 7.84454811,19.0417079 C8.19335784,18.0804242 8.46831296,16.7923277 8.61882369,15.4146121 C8.70295054,14.6442562 8.89974727,14.0204903 9.18785736,13.610744 C9.29102644,13.464072 9.44056272,13.44824 9.5000443,13.44824 C9.55952588,13.44824 9.70906217,13.464072 9.81223124,13.610785 C10.1003413,14.0204903 10.2971381,14.6442562 10.3812649,15.4146532 C10.5317756,16.7923277 10.8067308,18.0804652 11.1555405,19.0417489 C11.627333,20.342109 12.2337203,21 12.9594361,21 C13.0006063,21 13.0421825,20.9978672 13.0840835,20.9936836 C13.8213303,20.9191992 14.4372184,20.3008883 14.9146139,19.1559365 C15.3131202,18.2001488 15.6212876,16.8841208 15.8305084,15.2444382 C15.9001811,14.6983559 15.9849981,14.184963 16.0825236,13.7185741 C16.3020167,12.6690247 16.7481082,11.6819421 17.4084147,10.7847248 C18.9224137,8.72754398 19.3916077,6.1312945 18.6634963,3.83983229 Z M16.6129946,10.0415451 C15.8275318,11.1075318 15.2961146,12.2839205 15.0334884,13.5380571 C14.9265635,14.0485876 14.8339675,14.6079942 14.7582412,15.2006854 C14.3213361,18.6204581 13.5072156,19.9405334 13.0607302,20 C12.9669679,19.9664633 12.6462348,19.6553877 12.301426,18.6262157 C12.009184,17.7540944 11.7754238,16.6075861 11.6430902,15.3978709 C11.5319999,14.381979 11.2606264,13.5615076 10.836509,12.9591925 C10.5297299,12.5234681 10.0300945,12.2633278 9.50001023,12.2633278 C8.96992597,12.2633278 8.47029052,12.523426 8.16346979,12.9592345 C7.7393524,13.5615916 7.46802057,14.3820631 7.35688865,15.3979129 C7.22455502,16.6076281 6.99079478,17.7541364 6.69859447,18.6262577 C6.35378562,19.6554297 6.03301091,19.9665054 5.93924856,20 C5.49280482,19.9405754 4.67864271,18.6205002 4.24173765,15.2007274 C4.16601133,14.6081623 4.07341528,14.0486717 3.96644873,13.537847 C3.70365589,12.2827017 3.17282187,11.1071956 2.38873369,10.0438985 C1.07385314,8.26095014 0.661523732,6.02450037 1.28562026,4.06142902 C1.72902329,2.6667158 2.64623651,1.65233689 3.80208345,1.27839052 C5.02228527,0.883557285 6.28051686,0.90885687 7.54178917,1.35349079 C8.50515462,1.69314403 9.10967394,2.16295146 9.11417254,2.16648163 L9.49909385,2.47011869 L9.88430674,2.16765836 C9.89030487,2.16295146 10.4948242,1.69314403 11.4581896,1.35349079 C12.7194619,0.908814844 13.9776519,0.883557285 15.1978954,1.27839052 L15.197937,1.27839052 C16.3534091,1.65221081 17.270539,2.66621149 17.714067,4.06033634 C18.3383301,6.02265123 17.9267505,8.25863872 16.6129946,10.0415451 Z" id="Shape" fill="#FFFFFF" fill-rule="nonzero"></path>
                  </g>
                </svg></i>
              <drop-down :data="ddDinte"
                         :value="data.dinte"
                         @selected="Handle_Tooth"/>
            </div>

            <div class="mtop12px relative">
              <i class="absolute left0 top0 flex-center">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.5 12C16.8283 12 17.1534 11.9353 17.4567 11.8097C17.76 11.6841 18.0356 11.4999 18.2678 11.2678C18.4999 11.0356 18.6841 10.76 18.8097 10.4567C18.9353 10.1534 19 9.8283 19 9.5C19 8.83696 18.7366 8.20107 18.2678 7.73223C17.7989 7.26339 17.163 7 16.5 7C15.837 7 15.2011 7.26339 14.7322 7.73223C14.2634 8.20107 14 8.83696 14 9.5C14 9.8283 14.0647 10.1534 14.1903 10.4567C14.3159 10.76 14.5001 11.0356 14.7322 11.2678C15.2011 11.7366 15.837 12 16.5 12ZM9 11C9.79565 11 10.5587 10.6839 11.1213 10.1213C11.6839 9.55871 12 8.79565 12 8C12 7.20435 11.6839 6.44129 11.1213 5.87868C10.5587 5.31607 9.79565 5 9 5C8.20435 5 7.44129 5.31607 6.87868 5.87868C6.31607 6.44129 6 7.20435 6 8C6 8.79565 6.31607 9.55871 6.87868 10.1213C7.44129 10.6839 8.20435 11 9 11ZM16.5 14C14.67 14 11 14.92 11 16.75V19H22V16.75C22 14.92 18.33 14 16.5 14ZM9 13C6.67 13 2 14.17 2 16.5V19H9V16.75C9 15.9 9.33 14.41 11.37 13.28C10.5 13.1 9.66 13 9 13Z" fill="white"/>
                </svg>
              </i>
              <drop-down :data="Doctor"
                         :value="data.doctor"
                         @selected="Handle_Doctor"/>
            </div>

            <validation-provider rules="required"
                                 v-slot="{ errors }">
              <textarea class="mtop12px"
                        :class="{'invalid-input': errors[0]}"
                        :disabled="disabled"
                        @input="Handle_Note_Keyup"
                        v-model="data.detalii"
                        cols="30" rows="12"
                        placeholder="detalii" />
            </validation-provider>
            <br><br><br>

            <div class="actions flex flex-between">
              <div v-if="data.pics"
                   class="mauto">
                <upload-img-btn label="nota"
                                :disabled="disabled"
                                :formats="formats"
                                :img="data.pics[0]"
                                @remove-file="Handle_Remove_Img"
                                @select-img="Handle_Img" />
              </div>
            </div>


            <div v-if="!serverDetalii" class="flex flex-between">
              <delete-tratament-btn @delete-tratament="Handle_Delete_Note"
                                    @set-delete-mode="_checkDelete" />

              <button class="submit-btn flex-center m-left-auto submit-active opa"
                      :disabled="disabled">
                <i v-html="svg.save" />
              </button>
            </div>

            <div class="conflict-actions" v-else>
              <p>Atenție: pe server există o versiune mai nouă a acestei note →</p>

              <div>

                <div>
                  <button
                    @click="Handle_Close"
                    class="cancel"
                  >
                    Închide
                  </button>
                  <p class="close-note">*nota de pe server rămâne neschimbată</p>
                </div>

                <div>
                  <button
                    type="button"
                    @click="handleApproveChanges"
                    class="approve"
                  >
                    Salvati
                  </button>
                  <p class="save-note">*se va suprascrie nota de pe server <br/>
                    cu versiunea de mai sus
                  </p>
                </div>
              </div>
            </div>

            <p v-if="errorMessage" class="error-text">{{ errorMessage }}</p>
          </form>
      </ValidationObserver>
      <NoteConflictPreview :server-detalii="serverDetalii"/>
    </div>
  </section>

</template>

<script>
  import {mapState} from 'vuex';
  import {historyModal} from '@/mixins';
  import {debounce} from 'lodash';
  import NoteConflictPreview from "@/components/Note_Conflict_Preview.vue";
  export default {
    name: 'add-nota-modal',
    components: {NoteConflictPreview},
    mixins: [historyModal],
    data () {
      return {
        ddDinte: {
          name: 'dinte',
          placeholder: 'dinte',
          ddData: 'dinti'
        },
        Doctor: {
          name: 'doctor',
          placeholder: 'doctor',
          ddData: 'medici',
          validation: true
        },
        formats: ['.jpg', '.JPG', '.jpeg', '.png', '.bmp', '.gif', '.doc', '.docx', '.xls', '.xlsx', '.txt', '.pdf', '.rtf']
      }
    },
    computed: {
      ...mapState({
        user: 'user',
        isUpdateModal: 'isUpdateModal',
        svg: 'svg'
      }),
      data () {
        return this.$store.state.note.note;
      },
      doctors () {
        return this.$store.state.medici;
      },
      disabled () {
        return false;
      },
      serverDetalii () {
        return this.$store.state.note.server_conflict_detalii;
      },
      errorMessage () {
        return this.$store.state.note.last_error_message;
      },

    },
    methods: {
      Handle_Tooth ({ name, value }) {
        this.$store.commit('SET_NOTE_FIELD', { key: name, value });
      },
      Handle_Doctor ({ name, value }) {
        this.$store.commit('SET_NOTE_FIELD', { key: name, value });
      },
      Handle_Img ({ file, picName }) {
        this.$store.commit('ADD_IMGS_TO_NOTE', { file, picName });
      },
      Handle_Remove_Img () {
        this.$store.commit('REMOVE_NOTE_IMG', true);
      },
      Handle_Note_Keyup (ev) {
        const value = ev.target.value
        this.$store.commit('SET_NOTE_FIELD', { key: 'detalii', value: value });
        this.Save_Draft(value);
      },
      Save_Draft (value) {
        localStorage.setItem(
          `note-draft-${this.data.id || 'new-note'}`,
          value
        );
      },
      Handle_Close () {
        this.$store.commit('CLEAR_NOTE_CONFLICT');
        this.$store.commit('CLEAR_NOTE_ERROR');
        this.$emit('close');
      },
      Handle_Delete_Note () {
        this.$store.dispatch('delete_note');
      },
      async submit () {
        this.$store.commit('CLEAR_NOTE_ERROR');
        const res = await this.$store.dispatch('handle_note');
        if (res && res.ok) {
          this.$store.commit('TOGGLE_MODAL', false);
        }
      },
      async handleApproveChanges() {
        await this.$store.dispatch('handle_note', { overwrite: true });
        this.$store.commit('TOGGLE_MODAL', false);

        this.Handle_Close();
      },
    },
    created () {
      this.saveDraft = debounce(this.Save_Draft, 500);
    }
  }
</script>

<style lang="less">
  @import "../assets/styles/mixin";
  @import "../assets/styles/var";

  .add-nota-modal {

    .error-text {
      color: #FF1313;
      font-family: "Montserrat", sans-serif;
      font-size: 1.6rem;
      text-align: center;
      margin-top: 12px;
    }

    .conflict-actions {
      > p {
        font-family: "Montserrat", sans-serif;
        font-size: 1.7rem;
        font-weight: 500;
        color: #FF1313;
        text-align: center;
      }

      > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 20px;
        padding-top: 50px;

        > div {
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          flex: 1;
          gap: 7px;

          button {
            width: 162px;
            height: 46px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 4px;
            padding: 18px 20px;
            font-family: "Montserrat", sans-serif;
            font-size: 1.9rem;
            color: white;
            font-weight: 600;
            transition: opacity 0.1s ease-in;

            &:hover {
              opacity: 0.8;
            }

            &.cancel {
              background-color: #616161;
            }

            &.approve {
              background-color: #00BF9D;
            }

          }
          p {
            font-family: "Montserrat", sans-serif;
            font-size: 1.6rem;
            font-weight: 500;
            text-align: center;
            min-height: 40px;

            &.save-note {
              color: #00866E;
            }
          }
        }
      }
    }

    .wrapper-nota-modal {
      display: flex;
    }

    form {
      width: 900px!important;
      textarea {
        height: 300px;
        padding: 16px;
      }
      .submit-btn[disabled],
      .upload-img-btn label.disabled {
        opacity: 0.5;
        cursor: pointer;
        &:hover {
          background-color: @main-green;
        }
      }
    }

    .close-icon {
      top: -12px;
      right: -13px;
      transform: scale(1.3);
      transition: transform 0.1s ease;
      circle {
        fill: #454545;
      }
      polygon {
        fill: white;
      }
      &:hover {
        transform: scale(1.4);
      }
    }
  }
</style>
